import { createRandomSiteList } from './sites';
import { faker } from '@faker-js/faker';
import { createRandomCohortList } from './cohorts';
import { createRandomModalityLabelList } from './labels';
import { StudyStatusEnum } from '@dynamika-shared/types/status';
import { ClinicalTrialAffiliateNames } from '@dynamika-shared/types/clinicalTrialAffiliates';

export const CreateRandomClinicalTrialContext = () => {
  const randomNumber = faker.number.int({ min: 1, max: 5 });
  const nameCT = Object.values(ClinicalTrialAffiliateNames);
  const randomNumberCT = faker.number.int({
    min: 1,
    max: nameCT.length,
  });
  const randomName = nameCT[randomNumberCT - 1];

  const sites = createRandomSiteList(randomNumber);
  const cohorts = createRandomCohortList(randomNumber);
  const labelGroups = createRandomModalityLabelList(randomNumber);

  const data = {
    id: faker.string.uuid(),
    name: randomName,
    code: 'CT_1',
    sponsorId: faker.string.uuid(),
    status: faker.helpers.arrayElement([
      StudyStatusEnum.cancelled,
      StudyStatusEnum.closeUp,
      StudyStatusEnum.completed,
      StudyStatusEnum.maintenance,
      StudyStatusEnum.onHold,
      StudyStatusEnum.draft,
    ]),
    description: null,
    dataStorageLocationId: '678f0a2d-0e03-4f78-bcb1-fb59b1205381',
    iagStudyEmail: null,
    dashboardUrl: null,
    ctGovLink: null,
    eudraCt: null,
    phase: null,
    therapeuticArea: null,
    disease: null,
    drugMolecule: null,
    startDate: '2023-10-20',
    endDate: '2024-12-31',
    firstPatientVisit: null,
    lastPatientVisit: null,
    siteHypothesis: null,
    patientHypothesis: null,
    visitHypothesis: null,

    cohorts,
    labelGroups,
    sites,
  };

  return {
    data,
  };
};
